import { render, staticRenderFns } from "./BaseMaterialCard.vue?vue&type=template&id=128f01b8&scoped=true"
var script = {}
import style0 from "./BaseMaterialCard.vue?vue&type=style&index=0&id=128f01b8&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "128f01b8",
  null
  
)

export default component.exports